import authService from '../services/authService';
import { isTrueAdmin } from './roleAccess';

export const can = (permissionCode) => {
  const user = authService.getUser();
  if (!user) return false;

  if (isTrueAdmin(user)) {
    return true;
  }

  if (typeof user.role !== 'object') return false;

  const permissions = user.role?.permissions || [];
  return permissions.some((permission) => permission.code === permissionCode);
};

export const hasPermissionExact = (permissionCode, userOverride = null) => {
  const user = userOverride || authService.getUser();
  if (!user) return false;
  if (typeof user.role !== 'object') return false;

  const permissions = user.role?.permissions || [];
  return permissions.some((permission) => permission.code === permissionCode);
};

export const canAny = (...perms) => perms.some((permission) => can(permission));

export const isAdmin = () => {
  const user = authService.getUser();
  if (!user) return false;
  return isTrueAdmin(user);
};
